import { render, staticRenderFns } from "./ChurchSignup.vue?vue&type=template&id=955a9db8&"
import script from "./ChurchSignup.vue?vue&type=script&lang=js&"
export * from "./ChurchSignup.vue?vue&type=script&lang=js&"
import style0 from "./ChurchSignup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports